import React from "react";
import { Card } from "react-bootstrap";
import "./DashboardComponents.css";

// Phase 5. "Missing data is not zero" (§1) — null/undefined is ALWAYS
// rendered as an explicit label, never silently coerced to 0.
function formatValue(value, unit, isPercentage) {
  if (value === null || value === undefined) return "Not Available";
  const rounded = typeof value === "number" ? Math.round(value * 100) / 100 : value;
  if (isPercentage) return `${rounded}%`;
  if (unit) return `${rounded} ${unit}`;
  return String(rounded);
}

// Semantic accent derived from `direction` (already passed by every call
// site, so this needs no changes anywhere else) -- HIGHER_IS_BETTER reads
// as a positive/green metric, LOWER_IS_BETTER as a caution/red one,
// everything else stays a neutral informational blue. An explicit
// `accent` prop can still override this for a specific card (e.g. "Tasks
// Open" reads better as amber than as neutral blue).
function resolveAccent(direction, accentOverride) {
  if (accentOverride) return accentOverride;
  if (direction === "HIGHER_IS_BETTER") return "success";
  if (direction === "LOWER_IS_BETTER") return "danger";
  return "info";
}

export default function MetricCard({ label, value, unit, isPercentage, direction, subtext, insufficientData, icon, accent }) {
  const isNotAvailable = !insufficientData && (value === null || value === undefined);
  const displayValue = insufficientData ? "Insufficient Data" : formatValue(value, unit, isPercentage);
  const directionHint = direction === "HIGHER_IS_BETTER" ? "Higher is better" : direction === "LOWER_IS_BETTER" ? "Lower is better" : "Informational";
  const resolvedAccent = resolveAccent(direction, accent);
  const isEmpty = isNotAvailable || insufficientData;

  return (
    <Card className={`h-100 perf-metric-card perf-metric-${resolvedAccent}${isEmpty ? " perf-metric-empty" : ""}`}>
      <Card.Body>
        <div className="perf-metric-icon">
          <i className={`fa-solid ${isEmpty ? "fa-circle-question" : icon || "fa-chart-simple"}`} aria-hidden="true"></i>
        </div>
        <div className="perf-metric-label">{label}</div>
        <div className={`perf-metric-value${isEmpty ? " perf-metric-value-empty" : ""}`}>{displayValue}</div>
        {subtext && <div className="perf-metric-subtext">{subtext}</div>}
        <div className="perf-metric-hint">{directionHint}</div>
      </Card.Body>
    </Card>
  );
}
